import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../../config/Config";

const initialState = {
    loading: false,
    error: null,
    data: null,
    salaryStructures: [],
    count: null
};

export const fetchPayrollRules = createAsyncThunk(
    "fetchPayrollRules",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(
                `/crm/payroll/payroll-salary-rules-list?page=${body.page}&search=${body.search}`
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const addPayrollRule = createAsyncThunk(
    "addPayrollRule",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(
                "/crm/payroll/create-payroll-salary-rules",
                data
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const fetchSalaryStructure = createAsyncThunk(
    "fetchSalaryStructure",
    async (_, { rejectWithValue }) => {
        try {
            const response = await instance.get(
                "/crm/payroll/fetch-salary-structure"
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

const GeneratePayrollSlice = createSlice({
    name: "GeneratePayrollSlice",
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchPayrollRules.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPayrollRules.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.count = action.payload?.count;
            })
            .addCase(fetchPayrollRules.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });

        builder
            .addCase(addPayrollRule.pending, (state) => {
                state.loading = true;
            })
            .addCase(addPayrollRule.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(addPayrollRule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });

        builder
            .addCase(fetchSalaryStructure.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchSalaryStructure.fulfilled, (state, action) => {
                state.loading = false;
                state.salaryStructures = action.payload?.data;

            })
            .addCase(fetchSalaryStructure.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.data;
            });
    },
});

export default GeneratePayrollSlice.reducer;